module.exports = __webpack_public_path__ + "static/media/storm.d9efe83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/storm.png
// module id = 1019
// module chunks = 0